import { render, staticRenderFns } from "./LoadingAnimationSmall.vue?vue&type=template&id=af03963e&scoped=true"
import script from "./LoadingAnimationSmall.vue?vue&type=script&lang=ts"
export * from "./LoadingAnimationSmall.vue?vue&type=script&lang=ts"
import style0 from "./LoadingAnimationSmall.vue?vue&type=style&index=0&id=af03963e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af03963e",
  null
  
)

export default component.exports